import Button from "@mui/material/Button";
import GppBadIcon from '@mui/icons-material/GppBad';




export default function BtOrax({modo,color,margenSup,fontColor,hoverBack,hoverColor,alto,altoLetra,onClick,id,icono,leyenda})
{
    function btClicked(ev) {
            window.location = (modo === 'oraxulux' ? "/?modo=oraxulux":"/?modo=frater");
            sessionStorage.clear();
            localStorage.removeItem('Gestion');
    }

    return(
        <Button sx={{background:color,
                    ml:'4%',
                    mt:(margenSup)?margenSup:'3px',
                    color:(fontColor)?fontColor:'black',
                    '&:hover':{fontWeight:'bold',background:hoverBack,color:hoverColor},
                    height:(alto)?alto:'30px',
                    mb:'8px',
                    fontSize:(altoLetra)?altoLetra:'14px'}}
                variant={"outlined"} 
                onClick= {(onClick)?onClick:btClicked}
                id={id}>
            {(icono)?icono:<GppBadIcon
                sx={{boxShadow: 1,color:'red'}}
            />}
            {(leyenda)?leyenda:'_Logout'}
        </Button>
    )
}
